/** The Skills screens a route skeleton draws: the list, the editor and a skill's log. */
export type SkillsSkeletonKind = 'list' | 'editor' | 'logs';

/** What loads inside a drawn page: a route's shape, or the Secrets & variables tab. */
export type SkillsPanelKind = SkillsSkeletonKind | 'vault';

/**
 * Anchored at both ends: `skills-mvp`, the campaigns screens and a path that merely
 * holds the word `skills` never match. The skill id is one free segment, so the check
 * runs before RouteSkeleton's substring tests (`/home`, `/inbox`, `/metrics`, …).
 * No lookbehind: Babel can't transpile one and Safari < 16.4 rejects it.
 */
const SKILLS_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/skills(?:\/([^/]+)(\/logs)?)?\/?$/;

/**
 * Which Skills screen a path opens, as AS/router declares them: the section root is
 * the list, `new` and `:skillId` the editor, `:skillId/logs` the log.
 */
export function skillsSkeletonKind(pathname: string): SkillsSkeletonKind | null {
  const match = SKILLS_ROUTE.exec(pathname);
  if (!match) return null;
  if (!match[1]) return 'list';
  return match[2] ? 'logs' : 'editor';
}
